import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";
const GetAppointments = async () => {
  /**
   * input: null
   * output: appointment object
   * description: get appointments / appointments array
   */
  try {
    const AppointmentsCollection = await collection(db, "appointments");
    const q = query(
      AppointmentsCollection,
      where("bid", "==", getLocalStorageItem("bid"))
    );
    const AppointmentsSnapshot = await getDocs(q);

    let AppointmentsArray = [];
    AppointmentsSnapshot.forEach((appointment) =>
      AppointmentsArray.push({ id: appointment.id, ...appointment.data() })
    );
    return AppointmentsArray;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default GetAppointments;
